module.exports = __webpack_public_path__ + "img/intro1.48a365d3.jpg";